export enum CardSize {
  ExtraSmall = 'XS',
  Small = 'S',
  Medium = 'M',
}
